module.exports = __webpack_public_path__ + "img/folder-dark-yellow.98d40968.svg";